module.exports = __webpack_public_path__ + "img/error.bd4f8e1d.png";